module.exports = __webpack_public_path__ + "static/media/covi_phy_15_min.f2929361.png";